import { render, staticRenderFns } from "./UserInfoEditForm.vue?vue&type=template&id=6edab6e1&"
import script from "./UserInfoEditForm.vue?vue&type=script&lang=js&"
export * from "./UserInfoEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports